import ProtectedRoute from 'auth/ProtectedRoute';
import SectionMenu from 'components/section/SectionMenu';
import { SectionPage } from 'components/section/SectionPage';
import React from 'react';
import { Switch } from 'react-router';
import styled from 'styled-components';

const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

interface Props {
  sectionPages: SectionPage[];
  className?: string;
}

interface State {
}

class SectionContainer extends React.Component<Props, State> {

  render(): React.ReactElement {
    const {sectionPages, className} = this.props;
    return (
        <ContentDiv className={`${className || ""}`}>
          <SectionMenu sectionPages={sectionPages}/>
          {this.renderRoutes()}
        </ContentDiv>
    );
  }

  renderRoutes = () => {
    let routes = [];
    const {sectionPages} = this.props;
    for (let page of sectionPages) {
      if (page.disabled === true) {
        continue;
      }
      routes.push(<ProtectedRoute path={page.uri} component={page.component} key={`${page.id} route`} exact/>);
    }

    return (
        <Switch>
          {routes}
        </Switch>
    );
  };
}

export default SectionContainer;
